import Glide, { Swipe } from '@glidejs/glide/dist/glide.modular.esm'

const MAX_PER_VIEW = 4

export default function InitColorBoxSlider() {
    document.querySelectorAll('[data-color-box-slider]').forEach((sliderEl) => {
        // nothing to slide (e.g. collection still empty while editing) — skip
        // mounting glide entirely rather than risk it erroring on 0 slides
        if (!sliderEl.querySelector('.glide__slide')) {
            return
        }

        const root = sliderEl.closest('.color-box-slider')
        const controls = sliderEl.querySelector('[data-color-box-slider-controls]')
        const cards = root.querySelectorAll('.color-box-slider__card')

        // fewer boxes than fit in a row — lay them out as a static, wrapping
        // grid instead of mounting glide. glide's "carousel" type clones
        // slides to fill up the perView slots when there are fewer real
        // slides than that, which visually repeats a single box several times.
        if (cards.length <= MAX_PER_VIEW) {
            sliderEl.classList.add('color-box-slider__slider--static')
            if (controls) {
                controls.style.display = 'none'
            }
            return
        }

        const prevButton = sliderEl.querySelector('[data-color-box-slider-prev]')
        const nextButton = sliderEl.querySelector('[data-color-box-slider-next]')

        const getSliderSettings = () => {
            if (window.matchMedia('(max-width: 576px)').matches) {
                return { perView: 1, peek: { before: 0, after: 30 }, gap: 12 }
            }
            if (window.matchMedia('(max-width: 991px)').matches) {
                return { perView: 2, peek: { before: 0, after: 40 }, gap: 16 }
            }
            if (window.matchMedia('(max-width: 1199px)').matches) {
                return { perView: 3, peek: { before: 0, after: 60 }, gap: 20 }
            }
            return { perView: MAX_PER_VIEW, peek: { before: 0, after: 90 }, gap: 20 }
        }

        const sliderSettings = getSliderSettings()

        // no loop (client request, applies to every slider on the site) —
        // "slider" + bound:true stops firmly at the last slide instead of
        // "carousel"/rewind wrapping back to the start
        const glide = new Glide(sliderEl, {
            type: 'slider',
            bound: true,
            // glide.js defaults "rewind" to true even for "slider" type —
            // without this it silently wraps around
            rewind: false,
            perView: sliderSettings.perView,
            peek: sliderSettings.peek,
            gap: sliderSettings.gap,
            animationDuration: 400,
            // Neos.Neos:ContentCollection wraps the cards in its own
            // ".neos-contentcollection" div — treat it as the slides track
            classes: { slides: 'neos-contentcollection' },
        })

        const updateArrows = () => {
            prevButton?.classList.toggle('is-disabled', glide.index === 0)
            nextButton?.classList.toggle('is-disabled', glide.index + glide.settings.perView >= cards.length)
        }

        if (prevButton) {
            prevButton.addEventListener('click', () => glide.go('<'))
        }

        if (nextButton) {
            nextButton.addEventListener('click', () => glide.go('>'))
        }

        glide.on(['mount.after', 'run'], updateArrows)
        glide.mount({ Swipe })

        window.addEventListener('resize', () => {
            const nextSettings = getSliderSettings()
            glide.update({ perView: nextSettings.perView, peek: nextSettings.peek, gap: nextSettings.gap })
        })
    })
}
